import {
  ActionIcon,
  Box,
  Button,
  FileButton,
  Alert,
  Flex,
  Grid,
  Group,
  Loader,
  LoadingOverlay,
  Menu,
  ScrollArea,
  Select,
  Text,
  Title,
  Tooltip,
  TypographyStylesProvider,
  TextInput,
  Pagination,
} from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import { randomId, useDisclosure, useDebouncedValue } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import "@mantine/notifications/styles.css";
import {
  LocalizationMap,
  RenderPage,
  RenderPageProps,
  ScrollMode,
  SpecialZoomLevel,
  Viewer,
  Worker,
} from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { renderPremiumToolbar } from "../../component/PremiumPdfToolbar";
import { ContractSummaryPanel } from "../../component/ContractSummaryPanel";
import de_DE from "@react-pdf-viewer/locales/lib/vi_VN.json";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import {
  IconCommand,
  IconDownload,
  IconEdit,
  IconEye,
  IconNoteOff,
  IconRecycle,
  IconSearch,
  IconSignature,
  IconTrash,
  IconUpload,
  IconWritingSign,
  IconX,
  IconZoomIn,
  IconAlertCircle,
  IconInfoCircle,
  IconMenu2,
  IconCloud,
  IconHelp,
  IconPaperclip,
} from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";
import { Rnd } from "react-rnd";
import {
  AvatarUtils,
  convertSignType,
  repositorySign,
  workerUrl,
} from "../../_base/_const/_constVar";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { GetStepSignModel } from "../../model/GetStepSignModel";
import { MessageResponse } from "../../model/MessageResponse";
import { SignAccessModel } from "../../model/SignAccessModel";
import "./Main.css";
import "./pdf.component.css";
import "./tab.component.css";

import Signature, { SignatureRef, StrokeOptions } from "@uiw/react-signature";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Loading } from "../../_base/component/_layout/Loading";
import { SelectListItem } from "../../_base/model/_base/SelectListItemBase";
import { ListStepSign } from "../../model/SignPage";
import { SignRejectModel } from "../../model/SignRejectModel ";

import { Link, RichTextEditor } from "@mantine/tiptap";
import "@mantine/tiptap/styles.css";
import { scrollModePlugin } from "@react-pdf-viewer/scroll-mode";
import Highlight from "@tiptap/extension-highlight";
import SubScript from "@tiptap/extension-subscript";
import Superscript from "@tiptap/extension-superscript";
import TextAlign from "@tiptap/extension-text-align";
import Underline from "@tiptap/extension-underline";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import { getUsersSelect } from "../../const/getSelectApi";
import { TblComment } from "../../model/Tblcomment";
import { ImageCore } from "./ImageCore";
import { PdfFileView } from "./PdfFileView";
import PdfOnlyViewer from "./PdfOnlyViewer";

import { saveAs } from "file-saver";
import JSZip from "jszip";
import { SimpleEditor } from "../../@/components/tiptap-templates/simple/simple-editor";
import { EcmNodeContent } from "../../model/EcmNodeContent";
import { getFileNames, uploadFile, UploadFileResult } from "../../_base/extension/Extension";
import {
  checkHacomSignPlugin,
  filesToSign,
  HacomSignPluginCheck,
  signFileWithPlugin,
  signPositionsForFile,
} from "../../_base/helper/HacomSignPlugin";
import { openHacomSignPluginModal } from "../../component/HacomSignPluginModal";
import { TagUsersSection, TagUser } from "../../_base/component/CommentComponents/TagUsersSection";
import { CommentAttachmentSection } from "../../_base/component/CommentComponents/CommentAttachmentSection";
import { AttachmentListModal } from "../../_base/component/CommentComponents/AttachmentListModal";

// Cloud Signing interfaces
interface CloudSignatureInfo {
  type: string;
  user: string;
  pass: string;
  pin: string;
}

interface RmsSignResponse {
  success: boolean;
  fileName?: string;
  fileUrl?: string;
  message?: string;
  errorMessage?: string;
}



// Interface for CommentAttachmentSection props


const USERS_PER_PAGE = 6;

const SignTopage = () => {
  let params = useParams();
  const navigate = useNavigate();
  const [urlFile, setUrlFile] = useState<string>("");
  const [saveFile, setSaveFile] = useState<Uint8Array>();
  const [selectFile, setSelectFile] = useState<string>("");
  const [listFile, setListFile] = useState<Array<string>>([]);
  const [documentData, setDocument] = useState<GetStepSignModel>();
  const [listComment, setListComment] = useState<TblComment[]>();
  const [data, setData] = useState<Array<ListStepSign>>([]);
  const [employ, setEmployee] = useState<SelectListItem[]>([]);
  const [isView, setIsView] = useState<boolean>();
  const [searchParams] = useSearchParams();
  const [attachments, setAttachments] = useState<string>("");
  const [tagUsers, setTagUsers] = useState<TagUser[]>([]);
  const [isLoadingTagUsers, setIsLoadingTagUsers] = useState(false); // Thêm state này
  const [fileNameDownloadV2, setFileNameDownloadV2] = useState<
    EcmNodeContent[]
  >([]);
  const [filesOutdated, setFilesOutdated] = useState(false);
  const [isLatestVersion, setIsLatestVersion] = useState<boolean | null>(null);
  const [isLoadingVersion, setIsLoadingVersion] = useState(false);
  const [pluginCheck, setPluginCheck] = useState<HacomSignPluginCheck>();
  // Cloud Signing states
  const [cloudSignatures, setCloudSignatures] = useState<CloudSignatureInfo[]>([]);
  const [isLoadingCloudSign, setIsLoadingCloudSign] = useState(false);
  const editor = useEditor({
    extensions: [
      StarterKit,
      Underline,
      Link,
      Superscript,
      SubScript,
      Highlight,
      TextAlign.configure({ types: ["heading", "paragraph"] }),
    ],
    editorProps: {
      handlePaste(view, event, slice) {
        const clipboardData = event.clipboardData;
        const text = clipboardData?.getData("text/plain");

        if (text) {
          event.preventDefault();

          // Chuyển từng dòng thành 1 đoạn văn
          const lines = text
            .split(/\r?\n/)
            .filter((line) => line.trim() !== "")
            .map((line) => `<p>${line}</p>`)
            .join("");

          editor?.commands.insertContent(lines);
          return true;
        }

        return false;
      },
    },
  });
  useEffect(() => {
    if (!params.id || Number.parseInt(params.id) < 1) {
      navigate("/method/approve-task");
    } else {
      if (searchParams.get("view") === "1") {
        setIsView(true);
      } else setIsView(false);
      addLocationSign(Number.parseInt(params.id));
      fetchDataEmployee();
      fetchTagUsers(); // Thêm gọi fetchTagUsers
    }
  }, []);

  const fetchDataEmployee = async () => {
    const dataApi = await getUsersSelect();
    if (dataApi && dataApi.length > 0) {
      const filteredData = dataApi.filter((item) => item.text !== null);
      setEmployee(filteredData);
    }
  };

  // Thêm hàm fetchTagUsers
  const fetchTagUsers = async () => {
    setIsLoadingTagUsers(true); // Bắt đầu loading
    try {
      const response = await repositorySign.get<MessageResponse<TagUser[]>>(
        `/api/v1/users/get-all`
      );
      if (response && response.success) {
        setTagUsers(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching tag users:", error);
    } finally {
      setIsLoadingTagUsers(false); // Kết thúc loading
    }
  };

  const fullName = localStorage.getItem("fullName");
  const addLocationSign = async function (id: number) {
    if (documentData) return;
    const url =
      "/api/v1/SignPage/get-step-sign?id=" +
      id +
      "&isView=" +
      (searchParams.get("view") === "1");
    const res = await repositorySign.get<MessageResponse<GetStepSignModel>>(
      url
    );
    if (res && res.httpStatusCode === 200) {
      if (res.success) {
        const filesss =
          res.data?.signaturePages.map((item) => item.files).flat() || [];
        const filessss = res.data?.tblDocument.attachments || "";
        setAttachments(filessss);
        const file = Array.from(new Set(filesss));
        // danh sách file này được chụp lúc trình ký; nếu hồ sơ bị đổi file sau đó thì hai bên sẽ lệch nhau
        const currentFiles = (res.data?.tblDocument.signedDocument || "").split("||");
        setFilesOutdated(file.some((f) => !currentFiles.includes(f)));
        getFileNames(file).then((names) => {
          if (names && names.length > 0)
            setFileNameDownloadV2((prev) => [...prev, ...names]);
        });
        if (!file) NotificationExtension.Fails("Không tìm được file");
        else {
          const _f = file[0];
          const get = _f.split("/") ?? [];
          if (get && get.length > 0) {
            const _file = get[get.length - 1];
            setSelectFile(_file);
            setUrlFile(_f);
            setListFile(file);
          }
        }
        let _data: ListStepSign = res.data?.liststepsign; // Provide a default empty array
        _data.list = [];
        // Now, _data.list is guaranteed to be an array (even if it's empty)
        _data.list.push(...(res.data?.signaturePages || [])); // Safely push, handling undefined signaturePages

        const paster: Array<ListStepSign> = [];
        paster.push(_data);
        setData(paster);
        setDocument(res.data);
        setListComment(res.data.comments);
        if (res.data.tblDocument.signedDocument) {
          const urls = res.data.tblDocument.signedDocument.split("||");
          const getUserName = await getFileNames(urls);
          if (getUserName && getUserName.length > 0) {
            setFileNameDownloadV2((prev) => [...prev, ...getUserName]);
          }
        }
      } else NotificationExtension.Fails(res.message);
    }
  };

  const [boundaryElm, setBoundaryElm] = useState<HTMLDivElement>();
  // const workerUrl = new URL(
  //   "pdfjs-dist/build/pdf.worker.min.js",
  //   import.meta.url
  // ).toString();
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: renderPremiumToolbar,
  });
  // const disableScrollPluginInstance = disableScrollPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const {
    GoToFirstPage,
    GoToLastPage,
    GoToNextPage,
    GoToPreviousPage,
    CurrentPageLabel,
    jumpToPage,
  } = pageNavigationPluginInstance;
  const scrollModePluginInstance = scrollModePlugin();
  const $svg = useRef<SignatureRef>(null);
  const [options, setOptions] = useState<StrokeOptions>({
    size: 5,
    smoothing: 0.5,
    thinning: 0.5,
    streamline: 0.3,
  });

  const renderPage: RenderPage = (props: RenderPageProps) => {
    return (
      <>
        {props.canvasLayer.children}
        {props.textLayer.children}
        {data
          .filter((x) => x.typesigncustomer !== 0)
          .map((doc, index) =>
            doc.list
              .filter(
                (signaturePage) =>
                  signaturePage.page === props.pageIndex &&
                  signaturePage.files?.toString() === urlFile
              )
              .map((item, pageIndex) => (
                <Rnd
                  key={item.key}
                  bounds={boundaryElm}
                  size={{
                    width: item.width,
                    height: item.height,
                  }}
                  position={{
                    x: item.x,
                    y: item.y,
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "10px",
                    justifyContent: "center",
                    border:
                      selectedItemId === item.key
                        ? "solid 3.5px #228be6"
                        : "solid 2px #228be6",
                    background: "#fff",
                    color: "#228be6",
                    fontWeight: "bold",
                    zIndex: 9999,
                  }}
                >
                  {`${doc.name} ${convertSignType(
                    doc.typesigncustomer
                  )} ở bước ${doc.numberstep} `}
                </Rnd>
              ))
          )}
      </>
    );
  };

  const urlFront =
    "https://files.hacom.vn/hacom/Local/4oLmMUArial-Unicode-Regular (4).ttf";
  const [fontBytesFE, setFontBytes] = useState<ArrayBuffer>();
  useEffect(() => {
    const fetchFont = async () => {
      try {
        const response = await fetch(urlFront);
        const fontData = await response.arrayBuffer();
        setFontBytes(fontData);
      } catch (error) {
        console.error("Error fetching font:", error);
      }
    };

    fetchFont();
  }, []); // Empty dependency array means it runs only on mount

  useEffect(() => {
    if (saveFile) setData([]);
  }, [saveFile]);

  const applyPluginCheck = (check: HacomSignPluginCheck) => {
    setPluginCheck(check);
    setIsLatestVersion(check.status === "ready");
  };

  const checkVersion = async () => {
    setIsLoadingVersion(true);
    try {
      const check = await checkHacomSignPlugin();
      applyPluginCheck(check);
      return check;
    } finally {
      setIsLoadingVersion(false);
    }
  };

  // Ký số USB bằng HacomSign: ký lần lượt mọi file có vị trí ký của bước rồi mới xác nhận với API
  // Trả về true khi đã ký xong và đang chuyển trang: giữ khoá nút "Ký số" để không ký lại lần nữa
  const signDigitalWithPlugin = async (): Promise<boolean> => {
    const pages = stepSignaturePages();
    const files = filesToSign(pages);
    if (files.length === 0) {
      NotificationExtension.Fails("Bước ký không có vị trí ký số nào chưa ký.");
      return false;
    }
    open();
    let signed = false;
    try {
      let companyOrPerson = "";
      for (const fileUrl of files) {
        const result = await signFileWithPlugin(
          fileUrl,
          signPositionsForFile(pages, fileUrl)
        );
        if (!result.ok) {
          NotificationExtension.Fails(result.message);
          return false;
        }
        companyOrPerson = result.companyOrPerson;
      }
      const entity: SignAccessModel = {
        listStepId: documentData?.liststepsign.id ?? 0,
        signaturePages: [],
        name: "",
        urlImage: "",
        base64a: "123",
        base64b: "123",
        nameCompany: companyOrPerson,
      };
      const resSign = await repositorySign.post<
        MessageResponse<SignAccessModel>
      >("/api/v1/SignPage/sign-access-v2", entity);
      if (resSign?.httpStatusCode === 200 && resSign.success) {
        NotificationExtension.Success("Ký thành công !");
        signed = true;
        setTimeout(() => {
          navigate("/method/approve-task");
        }, 500);
      } else
        NotificationExtension.Fails(
          resSign?.message ??
            "Không xác nhận được bước ký với máy chủ. Hãy tải lại trang để kiểm tra trước khi ký lại."
        );
      return signed;
    } finally {
      if (!signed) close();
    }
  };

  // Chặn bấm "Ký số" lần nữa khi đang kiểm tra hoặc đang ký, tránh ký một file hai lần
  const digitalSigningRef = useRef(false);
  const [isDigitalSigning, setIsDigitalSigning] = useState(false);
  const startDigitalSign = async () => {
    if (digitalSigningRef.current) return;
    digitalSigningRef.current = true;
    setIsDigitalSigning(true);
    let keepLocked = false;
    try {
      const check = await checkVersion();
      if (check.status !== "ready") {
        openHacomSignPluginModal(check, openInstallGuideModal, applyPluginCheck);
        return;
      }
      keepLocked = await signDigitalWithPlugin();
    } finally {
      if (!keepLocked) {
        digitalSigningRef.current = false;
        setIsDigitalSigning(false);
      }
    }
  };

  const openInstallGuideModal = () => {
    modals.open({
      title: "Hướng dẫn cài đặt trình ký số",
      size: "xl",
      children: (
        <ScrollArea.Autosize mah={600}>
          <Box p="md">
            <Text size="sm" mb="md" c="gray.7">
              Để cài đặt bộ cài mới nhất, vui lòng làm theo các bước sau:
            </Text>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 1: Tải file gỡ cài đặt
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Tải file <strong>UnInstallHacomEsign.cmd</strong> để gỡ toàn bộ các phiên bản cũ đang có trên máy tính của bạn.
              </Text>
              <Button
                component="a"
                href="/UnInstallHacomEsign.cmd"
                download="UnInstallHacomEsign.cmd"
                leftSection={<IconDownload size={16} />}
                variant="light"
                color="blue"
                mb="md"
                fullWidth
              >
                Tải file UnInstallHacomEsign.cmd
              </Button>
            </Box>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 2: Chạy file gỡ cài đặt
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                1. Nhấp chuột phải vào file <strong>UnInstallHacomEsign.cmd</strong> và chọn <strong>"Chạy với tư cách quản trị viên hoặc run as administrator"</strong>
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                2. File sẽ tự động quét và tìm các phiên bản Hacom Sign đang có trên máy:
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "12px",
                }}
              >
                <img
                  src="/anhquetverrsion.png"
                  alt="Kết quả quét version"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>
              <Text size="sm" mb="xs" c="gray.7">
                3. Nhập <strong>'y'</strong> để xác nhận gỡ cài đặt. Quá trình sẽ tự động:
              </Text>
              <Box component="ul" style={{ paddingLeft: "20px", marginTop: "8px" }}>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">Đóng các ứng dụng Hacom Sign đang chạy</Text>
                </li>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">Gỡ cài đặt từ Registry</Text>
                </li>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">Xóa các file và thư mục còn sót lại</Text>
                </li>
              </Box>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginTop: "12px",
                }}
              >
                <img
                  src="/anhketquasaukhiquetxong.png"
                  alt="Kết quả sau khi gỡ xong"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>
            </Box>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 3: Tải và cài đặt bộ cài mới nhất
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Sau khi gỡ xong, tải bộ cài trình ký số mới nhất và cài đặt như bình thường.
              </Text>
              <Button
                component="a"
                href="https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe"
                leftSection={<IconDownload size={16} />}
                variant="filled"
                color="blue"
                mt="xs"
                fullWidth
              >
                Tải bộ cài trình ký số mới nhất
              </Button>
            </Box>

            {isLatestVersion !== true && (
              <Box
                style={{
                  padding: "12px",
                  backgroundColor: "#fff3cd",
                  borderRadius: "6px",
                  border: "1px solid #ffc107",
                  marginTop: "16px",
                }}
              >
                <Text size="xs" c="orange.8" fw={500}>
                  ⚠ Lưu ý: Quá trình gỡ cài đặt cần quyền Administrator. Vui lòng đảm bảo bạn đã chạy file với quyền quản trị viên.
                </Text>
              </Box>
            )}

            <Box
              style={{
                padding: "16px",
                backgroundColor: "#f8d7da",
                borderRadius: "8px",
                border: "2px solid #dc3545",
                marginTop: "20px",
              }}
            >
              <Text size="sm" fw={700} mb="md" c="red.8">
                ⚠️ CHÚ Ý QUAN TRỌNG: Cấp quyền truy cập mạng nội bộ
              </Text>
              <Text size="sm" mb="xs" c="gray.8" fw={500}>
                Một số máy tính có thể tắt chức năng truy cập mạng nội bộ, khiến không thể chạy test phiên bản hoặc ký số được vì call localhost báo lỗi.
              </Text>
              <Text size="sm" mb="md" c="gray.8" fw={500}>
                Để khắc phục, vui lòng làm theo các bước sau:
              </Text>

              <Box mb="md">
                <Text size="sm" fw={600} mb="xs" c="red.7">
                  Bước 1: Mở cài đặt trang web
                </Text>
                <Text size="sm" mb="xs" c="gray.7">
                  Nhấp vào biểu tượng khóa hoặc thông tin trang web ở thanh địa chỉ trình duyệt (bên trái URL)
                </Text>
              </Box>

              <Box mb="md">
                <Text size="sm" fw={600} mb="xs" c="red.7">
                  Bước 2: Bật quyền truy cập mạng nội bộ
                </Text>
                <Text size="sm" mb="xs" c="gray.7">
                  Tìm mục <strong>"Quyền truy cập mạng cục bộ"</strong> hoặc <strong>"Local network access"</strong> và bật chức năng này (chuyển sang màu xanh/ON)
                </Text>
                <Flex
                  gap="md"
                  mt="md"
                  direction={{ base: "column", sm: "row" }}
                >
                  <Box
                    style={{
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      overflow: "hidden",
                      flex: 1,
                    }}
                  >
                    <img
                      src="/anhcapquyentruycapmangnoibotiengviet.png"
                      alt="Cấp quyền truy cập mạng nội bộ (Tiếng Việt)"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </Box>
                  <Box
                    style={{
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      overflow: "hidden",
                      flex: 1,
                    }}
                  >
                    <img
                      src="/anhcapquyentruycapmangnoibo.png"
                      alt="Cấp quyền truy cập mạng nội bộ (English)"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </Box>
                </Flex>
              </Box>

              <Box
                style={{
                  padding: "10px",
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  border: "1px solid #dc3545",
                  marginTop: "12px",
                }}
              >
                <Text size="xs" c="red.8" fw={600}>
                  💡 Lưu ý: Sau khi bật quyền này, vui lòng tải lại trang để áp dụng thay đổi. Nếu vẫn gặp lỗi, hãy kiểm tra lại cài đặt tường lửa và phần mềm diệt virus.
                </Text>
              </Box>
            </Box>
          </Box>
        </ScrollArea.Autosize>
      ),
    });
  };

  useEffect(() => {
    checkVersion();
  }, []);

  const [listFileUpload, setListFileUpload] = useState<Array<SelectListItem>>(
    []
  );
  const [fileSign, setFileSign] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const downloadAllFiles = async () => {
    if (!listFile || listFile.length === 0) {
      NotificationExtension.Info("Không có tài liệu để tải xuống!");
      return;
    }
    const zip = new JSZip();
    // Tải từng file và thêm vào zip
    await Promise.all(
      listFile.map(async (fileUrl) => {
        const fileName =
          fileNameDownloadV2.find(
            (file) => file.fileName === fileUrl.split("/").pop()
          )?.originName ??
          (fileUrl.split("/").pop() ||
            documentData?.tblDocument.name ||
            documentData?.tblDocument.description ||
            "Tài liệu");
        const response = await fetch(fileUrl);
        const blob = await response.blob();
        console.log("Downloading file:", fileName);
        zip.file(fileName, blob);
      })
    );
    // Đặt tên file zip theo ngày và giờ hiện tại
    const nameZip =
      documentData?.tblDocument.name ||
      documentData?.tblDocument.description ||
      "TaiLieu_";
    const now = new Date();
    const pad = (n: number) => n.toString().padStart(2, "0");
    const zipName =
      nameZip +
      `_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
        now.getDate()
      )}.zip`;
    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, zipName);
    });
  };

  useEffect(() => {
    if (fileSign) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const imageData = fileReader.result;
        const imageUrl = `${imageData}`;
        setImageUrl(imageUrl);
      };
      fileReader.readAsDataURL(fileSign ?? new Blob());
    } else setImageUrl(null);
  }, [fileSign]);

  useEffect(() => {
    modals.closeAll();
    if (documentData && documentData.sign && documentData.sign.length > 0) {
      console.log("is profile !");
    } else showSignToHandeler();
  }, [imageUrl]);

  async function SignAcess(base: string) {
    if (!base || base.length < 10) {
      NotificationExtension.Fails("Bạn chưa vẽ chứ ký hoặc upload chữ ký !");
      return false;
    }
    if (base && base.length > 0) {
      const _user = employ.find(
        (x) => x.value === documentData?.liststepsign.username
      )?.text;
      let entity: SignAccessModel = {
        listStepId: documentData?.liststepsign.id ?? 0,
        name: _user,
        urlImage: base,
      };
      if (entity) {
        open();
        const urlApi = "/api/v1/SignPage/sign-access";
        var resSign = await repositorySign.post<
          MessageResponse<SignAccessModel>
        >(urlApi, entity);
        if (resSign && resSign.httpStatusCode === 200) {
          if (resSign.success) {
            NotificationExtension.Success("Ký tài liệu thành công !");
            setTimeout(() => {
              navigate("/method/approve-task");
            }, 1000);
          } else
            NotificationExtension.Fails(
              resSign.message ?? "Ký tài liệu thất bại !"
            );
        }
        close();
      }
    } else {
      NotificationExtension.Fails("Upload chữ ký thất bại do server lỗi !");
      return false;
    }
  }

  function showSignToHandeler() {
    if (
      !isView &&
      documentData?.liststepsign?.typesigncustomer &&
      documentData?.liststepsign?.typesigncustomer !== 0 &&
      documentData?.liststepsign?.typesigncustomer !== 2
    )
      modals.openConfirmModal({
        title: (
          <>
            <Title order={5}>Vẽ nội dung chữ ký vào bên dưới !</Title>
          </>
        ),
        size: "550px",
        children: (
          <>
            {" "}
            <Flex justify={"end"}>
              <Button
                size="xs"
                variant="outline"
                color="grape"
                leftSection={<IconRecycle />}
                onClick={() => {
                  $svg.current?.clear();
                  setImageUrl(null);
                  setFileSign(null);
                }}
                mb={10}
                mr={10}
              >
                Vẽ lại
              </Button>
              <FileButton onChange={setFileSign} accept="image/png">
                {(props) => (
                  <Button
                    size="xs"
                    variant="outline"
                    leftSection={<IconUpload />}
                    {...props}
                  >
                    {" "}
                    Chọn ảnh PNG
                  </Button>
                )}
              </FileButton>

              <Button
                disabled={!imageUrl}
                variant="outline"
                color="teal"
                size="xs"
                leftSection={<IconZoomIn />}
                onClick={() => {
                  modals.open({
                    title: "Xem ảnh",
                    children: (
                      <>
                        <ImageCore
                          h={"100%"}
                          src={imageUrl ?? ""}
                          fit="cover"
                        />
                      </>
                    ),
                  });
                }}
                mb={10}
                ml={10}
              >
                Xem ảnh phóng to
              </Button>
            </Flex>
            {imageUrl && imageUrl.length > 0 ? (
              <ImageCore src={imageUrl} />
            ) : (
              <Signature
                style={{
                  borderRadius: 5,
                  height: 210,
                  border: "1px solid #dee2e6",
                }}
                ref={$svg}
                options={options}
              />
            )}
          </>
        ),
        labels: { confirm: "Ký tài liệu", cancel: "Đóng" },
        onConfirm: async () => {
          if (documentData.sign && documentData.sign.length > 0) {
            await SignAcess(documentData.sign);
          } else {
            // Tạo một SVG Data URL
            let _base64 = "";
            if ($svg.current?.svg && !imageUrl) {
              const svgelm = $svg.current?.svg?.cloneNode(
                true
              ) as SVGSVGElement;
              const clientWidth = $svg.current?.svg?.clientWidth;
              const clientHeight = $svg.current?.svg?.clientHeight;
              svgelm.removeAttribute("style");
              svgelm.setAttribute("width", `${clientWidth}px`);
              svgelm.setAttribute("height", `${clientHeight}px`);
              svgelm.setAttribute("viewbox", `${clientWidth} ${clientHeight}`);
              const data = new XMLSerializer().serializeToString(svgelm);
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              const img = new Image();
              img.onload = async () => {
                canvas.width = clientWidth || 0;
                canvas.height = clientHeight || 0;
                ctx?.drawImage(img, 0, 0);
                const a = document.createElement("a");
                a.download = "signature.png";
                a.href = canvas.toDataURL("image/png");
                _base64 = a.href;
                await SignAcess(_base64);
              };
              img.src = `data:image/svg+xml;base64,${window.btoa(
                unescape(encodeURIComponent(data))
              )}`;
            } else if (imageUrl) {
              console.log(imageUrl);
              await SignAcess(imageUrl);
            }
          }
        },
      });
  }

  function addComment() {
    // Use a variable to store attachment URLs that can be accessed in onConfirm
    let commentAttachmentUrls = "";

    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thêm comment</Title>
        </>
      ),
      size: "70%",
      children: (
        <>
          <RichTextEditor editor={editor}>
            <RichTextEditor.Toolbar sticky stickyOffset={60}>
              <RichTextEditor.ControlsGroup>
                <RichTextEditor.Bold />
                <RichTextEditor.Italic />
                <RichTextEditor.Underline />
                <RichTextEditor.Strikethrough />
                <RichTextEditor.ClearFormatting />
                <RichTextEditor.Highlight />
                <RichTextEditor.Code />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.H1 />
                <RichTextEditor.H2 />
                <RichTextEditor.H3 />
                <RichTextEditor.H4 />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.Blockquote />
                <RichTextEditor.Hr />
                <RichTextEditor.BulletList />
                <RichTextEditor.OrderedList />
                <RichTextEditor.Subscript />
                <RichTextEditor.Superscript />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.Link />
                <RichTextEditor.Unlink />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.AlignLeft />
                <RichTextEditor.AlignCenter />
                <RichTextEditor.AlignJustify />
                <RichTextEditor.AlignRight />
              </RichTextEditor.ControlsGroup>

              <RichTextEditor.ControlsGroup>
                <RichTextEditor.Undo />
                <RichTextEditor.Redo />
              </RichTextEditor.ControlsGroup>
            </RichTextEditor.Toolbar>

            <RichTextEditor.Content />
          </RichTextEditor>

          {/* Thêm CommentAttachmentSection */}
          <CommentAttachmentSection
            onAttachmentsChange={(urls) => {
              commentAttachmentUrls = urls;
            }}
          />

          {/* Thêm TagUsersSection */}
          {editor && (
            <TagUsersSection
              tagUsers={tagUsers}
              editor={editor}
              USERS_PER_PAGE={USERS_PER_PAGE}
            />
          )}
        </>
      ),
      labels: { confirm: "Gửi", cancel: "Đóng" },
      onConfirm: async () => {
        let cmt = editor?.getHTML();
        if (!cmt) {
          NotificationExtension.Info("Chưa nhập comment !");
          return;
        }

        // Xử lý mention users
        let mentionedUserIds: number[] = [];
        const mentionRegex = /@\(([^)]+)\)/g;
        let match;

        while ((match = mentionRegex.exec(cmt)) !== null) {
          const mentionName = match[1];
          if (mentionName === "Báo cho cả nhóm") {
            mentionedUserIds.push(...tagUsers.map((u) => u.id));
          } else {
            const user = tagUsers.find((u) => u.name === mentionName);
            if (user && !mentionedUserIds.includes(user.id)) {
              mentionedUserIds.push(user.id);
              console.log("Found mention:", mentionName, "with ID:", user.id);
            }
          }
        }

        // Chuyển \r hoặc \r\n thành <br>
        cmt = cmt.replace(/(\r\n|\r|\n)/g, "<br>");
        const urlApi = "/api/v1/SignPage/add-comment-sign";
        var resSign = await repositorySign.post<MessageResponse<TblComment[]>>(
          urlApi,
          {
            setupId: documentData?.liststepsign.idsetupstepsign,
            content: cmt,
            mentionUserIds: mentionedUserIds.length > 0 ? mentionedUserIds : undefined,
            att1: commentAttachmentUrls.length > 0 ? commentAttachmentUrls : undefined,
          }
        );

        if (resSign && resSign.httpStatusCode === 200) {
          if (resSign.success) {
            NotificationExtension.Success("Thành công !");
            setListComment(resSign.data ?? []);
            editor?.commands.clearContent();
            modals.closeAll();
          } else
            NotificationExtension.Fails(
              resSign.message.length > 0 ? resSign.message : "Thất bại !"
            );
        }
      },
      closeOnConfirm: false,
    });
  }
  const [visible, { toggle, open, close }] = useDisclosure(false);

  // Hàm chuyển PDF từ URL sang base64
  async function pdfUrlToBase64(url: string): Promise<string> {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64data = reader.result as string;
        resolve(base64data);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  // Hàm trích xuất danh sách vị trí chữ ký
  const stepSignaturePages = () =>
    data.filter((x) => x.typesigncustomer !== 0).flatMap((x) => x.list);

  // Hàm lấy thông tin cloud signatures từ user profile
  const fetchCloudSignatures = async (): Promise<CloudSignatureInfo[]> => {
    try {
      const userName = localStorage.getItem("userName");
      if (!userName) return [];

      const response = await repositorySign.get<MessageResponse<any>>(
        `/api/v1/users/detail-username?userName=${userName}`
      );

      if (response?.success && response.data?.cloudSignatures) {
        const parsed = JSON.parse(response.data.cloudSignatures || "[]");
        return Array.isArray(parsed) ? parsed : [];
      }
      return [];
    } catch (error) {
      console.error("Error fetching cloud signatures:", error);
      return [];
    }
  };

  // Hàm gọi RMS Sign API
  const callRmsSignApi = async (
    cloudSign: CloudSignatureInfo,
    fileUrl: string,
    signaturePositions: Array<{ page: number; x: number; y: number; w: number; h: number }>
  ): Promise<RmsSignResponse> => {
    try {
      const rmsPositions = signaturePositions.map((pos) => ({
        page: pos.page.toString(),
        x: pos.x,
        y: pos.y,
        width: pos.w,
        height: pos.h,
      }));

      const requestBody = {
        userName: cloudSign.user,
        password: cloudSign.pass,
        pinCode: cloudSign.pin,
        usePinCode: cloudSign.pin?.length === 6,
        files: [
          {
            fileUrl: fileUrl,
            contentBase64: "",
            fileName: "",
            signaturePositions: rmsPositions,
          },
        ],
      };

      // Sử dụng repositorySign.postRaw để nhận response kể cả khi có lỗi HTTP
      const result = await repositorySign.postRaw<RmsSignResponse>(
        "/api/Rms/sign",
        requestBody
      );

      return result ?? { success: false, errorMessage: "Không nhận được phản hồi từ server" };
    } catch (error: any) {
      return {
        success: false,
        errorMessage: error?.message || "Lỗi kết nối đến server ký số Cloud",
      };
    }
  };

  // Hàm mở modal hướng dẫn ký số Cloud
  const openCloudSignGuideModal = () => {
    modals.open({
      title: <Title order={4}>Hướng dẫn ký số Cloud</Title>,
      size: "xl",
      children: (
        <ScrollArea.Autosize mah={600}>
          <Box p="md">
            <Text size="sm" mb="lg" c="gray.7">
              Thực hiện theo các bước sau để ký số Cloud thành công:
            </Text>

            {/* Bước 1 */}
            <Box mb="xl">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 1: Truy cập trang Thông tin cá nhân
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Click vào avatar ở góc trên bên phải màn hình, chọn <strong>Profile</strong>.
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <img
                  src="/kysocloud/b1.png"
                  alt="Bước 1: Truy cập Profile"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
            </Box>

            {/* Bước 2 */}
            <Box mb="xl">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 2: Nhập thông tin chữ ký Cloud
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Tại phần <strong>Chữ ký Cloud</strong>, nhập thông tin tài khoản, mật khẩu và mã PIN.
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <img
                  src="/kysocloud/b2.png"
                  alt="Bước 2: Nhập thông tin chữ ký Cloud"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
            </Box>

            {/* Bước 3 */}
            <Box mb="xl">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 3: Lưu thông tin
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Bấm nút <strong>Lưu thông tin</strong> để lưu cấu hình chữ ký Cloud.
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <img
                  src="/kysocloud/b3.png"
                  alt="Bước 3: Lưu thông tin"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
            </Box>

            {/* Bước 4 */}
            <Box mb="xl">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 4: Xác nhận ký số Cloud
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Khi ký tài liệu, bấm nút <strong>Ký số Cloud</strong>. Popup xác nhận sẽ hiển thị thông tin chữ ký.
                Bấm <strong>Xác nhận ký</strong> để tiến hành ký.
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <img
                  src="/kysocloud/b4.png"
                  alt="Bước 4: Popup xác nhận ký"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
            </Box>

            {/* Bước 5 */}
            <Box mb="md">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 5: Hoàn thành
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Chữ ký số sẽ được đóng dấu vào tài liệu như hình dưới đây.
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <img
                  src="/kysocloud/b5.png"
                  alt="Bước 5: Chữ ký thành công"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
            </Box>

            <Box
              style={{
                padding: "12px",
                backgroundColor: "#e7f5ff",
                borderRadius: "6px",
                border: "1px solid #74c0fc",
                marginTop: "16px",
              }}
            >
              <Text size="xs" c="blue.8" fw={500}>
                💡 Lưu ý: Nếu gặp lỗi "Mã PIN không khớp", vui lòng kiểm tra lại mã PIN trong trang Profile.
              </Text>
            </Box>
          </Box>
        </ScrollArea.Autosize>
      ),
    });
  };

  // Hàm mở modal chọn chữ ký Cloud
  const openCloudSignModal = async () => {
    setIsLoadingCloudSign(true);
    const signatures = await fetchCloudSignatures();
    setCloudSignatures(signatures);
    setIsLoadingCloudSign(false);

    if (signatures.length === 0) {
      modals.open({
        title: <Title order={5}>Chưa cấu hình chữ ký Cloud</Title>,
        children: (
          <Box>
            <Text size="sm" mb="md">
              Bạn chưa cấu hình thông tin chữ ký Cloud. Vui lòng vào trang{" "}
              <Text component="span" c="blue" fw={600}>
                Thông tin cá nhân
              </Text>{" "}
              để cài đặt.
            </Text>
            <Button
              fullWidth
              onClick={() => {
                modals.closeAll();
                navigate("/profile");
              }}
            >
              Đi đến trang cài đặt
            </Button>
          </Box>
        ),
      });
      return;
    }

    // Nếu có chữ ký cloud, mở modal để chọn và ký
    const firstSign = signatures[0]; // Tạm thời dùng chữ ký đầu tiên

    modals.openConfirmModal({
      title: <Title order={5}>Ký số Cloud (Remote Signing)</Title>,
      size: "md",
      children: (
        <Box>
          <Text size="sm" mb="md" c="dimmed">
            Bạn sẽ ký tài liệu bằng chữ ký số Cloud. Thông tin tài khoản đã được lưu trong hồ sơ của bạn.
          </Text>

          <Box
            p="md"
            mb="md"
            style={{
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              border: "1px solid #e9ecef",
            }}
          >
            <Group gap="xs" mb="xs">
              <IconCloud size={18} color="#15aabf" />
              <Text size="sm" fw={600}>Thông tin chữ ký</Text>
            </Group>
            <Text size="sm">
              <strong>Loại:</strong> {firstSign.type || "IntrustCA"}
            </Text>
            <Text size="sm">
              <strong>Tài khoản:</strong> {firstSign.user}
            </Text>
          </Box>

          <Text size="xs" c="orange.6" mb="xs">
            ⚠️ Lưu ý: Quá trình ký có thể mất vài giây. Vui lòng không đóng trang trong khi đang ký.
          </Text>
        </Box>
      ),
      labels: { confirm: "Xác nhận ký", cancel: "Hủy" },
      confirmProps: { color: "cyan" },
      onConfirm: async () => {
        open(); // Show loading overlay
        try {
          const pages = stepSignaturePages();
          let rmsResponse: RmsSignResponse = {
            success: false,
            errorMessage: "Bước ký không có vị trí ký số nào chưa ký.",
          };
          // Ký lần lượt mọi file có vị trí ký của bước rồi mới xác nhận
          for (const fileUrl of filesToSign(pages)) {
            rmsResponse = await callRmsSignApi(
              firstSign,
              fileUrl,
              signPositionsForFile(pages, fileUrl)
            );
            if (!rmsResponse.success) break;
          }

          if (rmsResponse.success) {
            // Ký RMS thành công, gọi API xác nhận
            let entity: SignAccessModel = {
              listStepId: documentData?.liststepsign.id ?? 0,
              signaturePages: [],
              name: "",
              urlImage: "",
              base64a: "123",
              base64b: "123",
              nameCompany: "",
            };

            const urlApi = "/api/v1/SignPage/sign-access-v2";
            const resSignType2 = await repositorySign.post<MessageResponse<SignAccessModel>>(
              urlApi,
              entity
            );

            if (resSignType2 && resSignType2.httpStatusCode === 200) {
              if (resSignType2.success) {
                NotificationExtension.Success("Ký số Cloud thành công!");
                setTimeout(() => {
                  navigate("/method/approve-task");
                }, 500);
              } else {
                NotificationExtension.Fails(resSignType2.message ?? "Xác nhận ký thất bại!");
              }
            }
          } else {
            // Ký RMS thất bại
            NotificationExtension.Fails(
              rmsResponse.errorMessage || rmsResponse.message || "Ký số Cloud thất bại!"
            );
          }
        } catch (error: any) {
          NotificationExtension.Fails("Lỗi khi thực hiện ký số Cloud: " + (error?.message || ""));
        } finally {
          close(); // Hide loading overlay
        }
      },
    });
  };

  return (
    <>
      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
          }
        `}
      </style>
      {isLatestVersion !== true && (
        <Box
          style={{
            background: "#fffbe6",
            border: "1px solid #ffe58f",
            padding: "8px",
            marginBottom: "10px",
            borderRadius: "6px",
            fontWeight: 600,
            color: "#ad8b00",
            fontSize: "16px",
            textAlign: "center",
          }}
        >
          ⚠️<span style={{ textDecoration: "underline" }}>Lưu ý:</span> Vui lòng
          kiểm tra phiên bản phần mềm trước khi ký (áp dụng cho loại là ký số).
          Cần bản <b>{pluginCheck?.minVersion ?? "1.0.7"}</b> trở lên.
          <a
            href={
              pluginCheck?.downloadUrl ??
              "https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe"
            }
            style={{ color: "#0078cb" }}
            rel="noopener noreferrer"
          >
            Truy cập tại đây
          </a>
          .
        </Box>
      )}
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              <Title size={15}>
                {" "}
                Đang kiểm tra, mã hóa tài liệu và thực hiện ký. Quá trình có thể
                mất nhiều thời gian do chính sách bảo mật...
              </Title>
              <Button onClick={close}>Đóng</Button>
            </Flex>
          ),
        }}
      />
      {documentData && (
        <>
          {filesOutdated && (
            <Alert
              color="orange"
              variant="light"
              icon={<IconAlertCircle size={18} />}
              title="File trên màn này khác file hiện tại của hồ sơ"
              mb="xs"
            >
              Đây là các file được lưu lúc trình ký. Hồ sơ đã bị đổi file sau đó nên danh sách
              hiện tại của hồ sơ (nút Tải xuống ở danh sách hồ sơ) có thể khác. Hãy báo người tạo hồ sơ
              trước khi duyệt hoặc ký.
            </Alert>
          )}
          <Grid>
            <Grid.Col span={{ base: 12, sm: 5 }}>
              <Flex
                gap="xs"
                justify="flex-start"
                align="center"
                direction="row"
                wrap="wrap"
              >
                Tài liệu ký
                <Select
                  label=""
                  key={randomId()}
                  placeholder="Chọn..."
                  value={selectFile}
                  onChange={(e) => {
                    const _key = e ?? "";
                    setSelectFile(_key);
                    if (_key.length > 1) {
                      const file = listFile.find((x) => x.includes(_key));
                      if (file) setUrlFile(file);
                    }
                  }}
                  data={listFile.map((x) => ({
                    label:
                      fileNameDownloadV2.find(
                        (file) => file.fileName === x.split("/").pop()
                      )?.originName ??
                      (x.split("/").pop() || "Tài liệu"),
                    value: x.split("/")[x.split("/").length - 1],
                  }))}
                />
                <Menu shadow="md" width={200}>
                  <Menu.Target>
                    <Button
                      leftSection={<IconDownload size={16} />}
                      variant="outline"
                    >
                      Tải file
                    </Button>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item
                      leftSection={<IconDownload size={16} />}
                      onClick={downloadAllFiles}
                    >
                      Tải xuống
                    </Menu.Item>
                    <Menu.Item
                      leftSection={<IconDownload size={16} />}
                      onClick={async () => {
                        if (!urlFile) {
                          NotificationExtension.Info("Không có file PDF để tải!");
                          return;
                        }
                        const fileName =
                          fileNameDownloadV2.find(
                            (file) => file.fileName === urlFile.split("/").pop()
                          )?.originName ??
                          urlFile.split("/").pop() ??
                          "TaiLieu.pdf";
                        const response = await fetch(urlFile);
                        const blob = await response.blob();
                        saveAs(blob, fileName);
                      }}
                    >
                      Tải PDF
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
                {documentData?.liststepsign?.typesigncustomer === 2 && (
                  <>
                    {/* <Button
                      leftSection={<IconSearch size={14} />}
                      color="teal"
                      variant="outline"
                      onClick={() => {
                        NotificationExtension.Info(
                          "Chức năng đang được phát triển1!"
                        );
                      }}
                    >
                      Kiểm tra chữ ký số
                    </Button> */}
                    <Box
                      style={{
                        padding: "8px 12px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "6px",
                        border: "1px solid #e9ecef",
                        minWidth: "200px",
                      }}
                    >
                      <Flex justify="space-between" align="center" gap="sm">
                        <Box>
                          {isLoadingVersion ? (
                            <Text size="xs" c="gray.6">
                              Đang kiểm tra version...
                            </Text>
                          ) : isLatestVersion === true ? (
                            <Text size="xs" c="green.6" fw={500}>
                              ✓ Bộ cài mới nhất
                            </Text>
                          ) : (
                            <Flex align="center" gap="xs">
                              <Text size="xs" c="orange.6" fw={500}>
                                {pluginCheck?.status === "notRunning"
                                  ? "⚠ Chưa kết nối HacomSign"
                                  : "⚠ Cần cập nhật HacomSign"}
                              </Text>
                              <IconAlertCircle
                                color="#ff6b6b"
                                size={14}
                                style={{
                                  animation: "blink 1s infinite",
                                }}
                              />
                            </Flex>
                          )}
                        </Box>
                        <Button
                          size="xs"
                          variant="light"
                          onClick={checkVersion}
                          loading={isLoadingVersion}
                          style={{
                            flexShrink: 0,
                          }}
                        >
                          Kiểm tra
                        </Button>
                      </Flex>
                      <Button
                        size="xs"
                        variant="subtle"
                        onClick={openInstallGuideModal}
                        leftSection={<IconInfoCircle size={14} />}
                        mt="xs"
                        fullWidth
                        color="blue"
                      >
                        Hướng dẫn cài đặt
                      </Button>
                    </Box>
                  </>
                )}
              </Flex>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 7 }}>
              <Flex
                gap="md"
                justify={{ sm: "flex-start", lg: "flex-end" }}
                align="center"
                direction="row"
                wrap="wrap"
              >
                {!isView &&
                  documentData?.liststepsign?.typesigncustomer != null &&
                  documentData?.liststepsign?.typesigncustomer > 0 && (
                    <>
                      <Button
                        leftSection={<IconWritingSign />}
                        color=""
                        variant="outline"
                        loading={isDigitalSigning}
                        onClick={async () => {
                          if (
                            documentData?.liststepsign?.typesigncustomer === 2
                          ) {
                            await startDigitalSign();
                          } else {
                            if (
                              documentData.sign &&
                              documentData.sign.length > 0
                            ) {
                              await SignAcess(documentData.sign);
                            } else showSignToHandeler();
                          }
                        }}
                        size="xs"
                      >
                        {documentData?.liststepsign?.typesigncustomer === 1
                          ? "Ký ảnh"
                          : documentData?.liststepsign?.typesigncustomer === 2
                            ? "Ký số"
                            : "Ký nháy"}
                      </Button>
                      {documentData?.liststepsign?.typesigncustomer === 2 && (
                        <>
                          <Tooltip label="Phần mềm hỗ trợ ký số">
                            <Button
                              variant="outline"
                              color="blue"
                              size="xs"
                              leftSection={<IconDownload />}
                              onClick={() => {
                                // window.location.href = "/HacomSignSetup.exe";
                                window.location.href =
                                  "https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe";
                              }}
                            >
                              Tải phần mềm ký số
                            </Button>
                          </Tooltip>
                          <Tooltip label="Ký số qua Cloud (không cần USB Token)">
                            <Button
                              variant="outline"
                              color="cyan"
                              size="xs"
                              leftSection={<IconCloud />}
                              onClick={openCloudSignModal}
                              loading={isLoadingCloudSign}
                            >
                              Ký số Cloud
                            </Button>
                          </Tooltip>
                          <Tooltip label="Hướng dẫn ký số Cloud">
                            <Button
                              variant="outline"
                              color="cyan"
                              size="xs"
                              leftSection={<IconHelp size={16} />}
                              onClick={openCloudSignGuideModal}
                            >
                              Hướng dẫn
                            </Button>
                          </Tooltip>
                        </>
                      )}
                    </>
                  )}
                {!isView &&
                  documentData?.liststepsign?.typesigncustomer != null &&
                  documentData?.liststepsign?.typesigncustomer === 0 && (
                    <Button
                      leftSection={<IconSignature />}
                      color=""
                      size="xs"
                      variant="outline"
                      onClick={async () => {
                        let entity: SignAccessModel = {
                          listStepId: documentData?.liststepsign.id ?? 0,
                          signaturePages: [],
                        };
                        if (entity) {
                          open();
                          const urlApi = "/api/v1/SignPage/sign-access";
                          var resSign = await repositorySign.post<
                            MessageResponse<SignAccessModel>
                          >(urlApi, entity);
                          if (resSign && resSign.httpStatusCode === 200) {
                            if (resSign.success) {
                              NotificationExtension.Success(
                                "Duyệt tài liệu thành công !"
                              );
                              setTimeout(() => {
                                navigate("/method/approve-task");
                              }, 500);
                            } else
                              NotificationExtension.Fails(
                                resSign.message ?? "Duyệt tài liệu thất bại !"
                              );
                          }
                          close();
                        } else
                          NotificationExtension.Fails("Lỗi khi duyệt chữ ký !");
                      }}
                    >
                      Phê duyệt
                    </Button>
                  )}
                {!isView && (
                  <Button
                    leftSection={<IconNoteOff />}
                    color="orange"
                    variant="outline"
                    size="xs"
                    onClick={async () => {
                      modals.openConfirmModal({
                        title: (
                          <Title order={5}>Xác nhận từ chối tài liệu</Title>
                        ),
                        children: (
                          <Text size="sm">
                            Bạn có chắc chắn muốn từ chối tài liệu này không?{" "}
                            Hành động này không thể hoàn tác.
                          </Text>
                        ),
                        labels: { confirm: "Từ chối", cancel: "Hủy" },
                        confirmProps: { color: "red" },
                        onConfirm: async () => {
                          let entity: SignRejectModel = {
                            listStepId: documentData?.liststepsign.id ?? 0,
                            setupId:
                              documentData?.liststepsign.idsetupstepsign ?? 0,
                          };
                          if (entity) {
                            const urlApi = "/api/v1/SignPage/sign-reject";
                            var resSign = await repositorySign.post<
                              MessageResponse<SignAccessModel>
                            >(urlApi, entity);
                            if (resSign && resSign.httpStatusCode === 200) {
                              if (resSign.success) {
                                NotificationExtension.Success(
                                  "Từ chối tài liệu thành công!"
                                );
                                setTimeout(() => {
                                  navigate("/method/approve-task");
                                }, 500);
                              } else
                                NotificationExtension.Fails(
                                  resSign.message ??
                                  "Từ chối tài liệu thất bại!"
                                );
                            }
                          } else
                            NotificationExtension.Fails(
                              "Lỗi khi từ chối duyệt!"
                            );
                        },
                      });
                    }}
                  >
                    Từ chối
                  </Button>
                )}
                <Button
                  size="xs"
                  variant="outline"
                  color="blue"
                  leftSection={<IconEye size={16} />}
                  onClick={async () => {
                    if (documentData?.tblDocument.signedDocument) {
                      modals.openConfirmModal({
                        title: <Title order={4}>Xem file ký</Title>,
                        size: "95%",
                        children: (
                          <PdfFileView
                            file={documentData.tblDocument.signedDocument}
                          />
                        ),
                        confirmProps: { display: "none" },
                        cancelProps: { display: "none" },
                      });
                    } else NotificationExtension.Fails("Hồ sơ chưa trình ký !");
                  }}
                >
                  Xem file ký
                </Button>

                <Button
                  size="xs"
                  variant="outline"
                  color="blue"
                  leftSection={<IconEye size={16} />}
                  onClick={async () => {
                    if (!attachments || attachments.length === 0) {
                      NotificationExtension.Info("Không có file đính kèm");
                      return;
                    }

                    modals.openConfirmModal({
                      title: <Title order={4}>Xem file đính kèm</Title>,
                      size: "80%",
                      radius: "md",
                      children: <PdfFileView file={attachments} />,
                      confirmProps: { display: "none" },
                      cancelProps: { display: "none" },
                    });
                  }}
                >
                  Xem file đính kèm
                </Button>

                <Button
                  variant="outline"
                  color="grape"
                  leftSection={<IconEdit />}
                  onClick={async () => {
                    await addComment();
                  }}
                  size="xs"
                  loading={isLoadingTagUsers}
                  disabled={isLoadingTagUsers}
                >
                  {isLoadingTagUsers ? "Đang tải..." : "Viết comment"}
                </Button>

                <Button
                  onClick={() => navigate("/method/approve-task")}
                  variant="outline"
                  size="xs"
                  color="gray"
                  leftSection={<IconX />}
                >
                  Đóng
                </Button>
              </Flex>
            </Grid.Col>
          </Grid>

          <Grid>
            <Grid.Col span={{ base: 12, sm: 7, md: 7.5 }}>
              {urlFile && !isView && (
                <div className="e-card" id="weather_card">
                  <div
                    className="rpv-core__viewer"
                    style={{
                      border: "1px solid rgba(0, 0, 0, 0.3)",
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <Group justify="center">
                      <div className="App" ref={(ref) => setBoundaryElm(ref!)}>
                        <Worker workerUrl={workerUrl}>
                          <Viewer
                            localization={de_DE as unknown as LocalizationMap}
                            fileUrl={saveFile ? saveFile : urlFile}
                            plugins={[
                              defaultLayoutPluginInstance,
                              pageNavigationPluginInstance,
                            ]}
                            scrollMode={ScrollMode.Vertical}
                            defaultScale={SpecialZoomLevel.ActualSize}
                            renderPage={!isView ? renderPage : undefined}
                          />
                        </Worker>
                      </div>
                    </Group>
                  </div>
                </div>
              )}
              {urlFile &&
                urlFile.length > 0 &&
                urlFile.startsWith("http") &&
                isView && (
                  <div className="control-section">
                    <PdfOnlyViewer files={urlFile} />
                  </div>
                )}
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 5, md: 4.5 }}>
              {documentData?.tblDocument?.id && documentData.tblDocument.id > 0 ? (
                <ContractSummaryPanel documentId={documentData.tblDocument.id} />
              ) : null}
              <div
                className="e-card"
                id="weather_card"
                style={{
                  position: "sticky",
                  top: 65,
                }}
              >
                <div className="e-card-header">
                  <div className="e-card-header-caption">
                    <div className="e-card-header-title e-card-3">
                      Chi tiết trao đổi
                    </div>
                    <ScrollArea mt={10} h={"80vh"} scrollbars="y">
                      <div style={{ padding: 0 }}>
                        {listComment?.map((itemComment, index) => (
                          <div
                            key={itemComment.id}
                            style={{
                              background: "#fff",
                              borderRadius: 12,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                              padding: 18,
                              marginBottom: 20,
                              position: "relative",
                              border: "1px solid #f0f0f0",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 8,
                              }}
                            >
                              <AvatarUtils
                                value={
                                  itemComment.username
                                    ?.toString()
                                    .split("-")[0] ?? ""
                                }
                                show={false}
                              />
                              <div style={{ marginLeft: 12, flex: 1 }}>
                                <Text
                                  size="sm"
                                  fw={600}
                                  style={{ color: "#2d3748" }}
                                >
                                  {itemComment.username}
                                </Text>
                                <Text
                                  size="xs"
                                  c="dimmed"
                                  style={{ fontSize: 12 }}
                                >
                                  {formatDateTransfer(itemComment.createdAt)}
                                </Text>
                              </div>
                              <ActionIcon
                                variant="light"
                                aria-label="Xóa bình luận"
                                color="red"
                                style={{
                                  position: "absolute",
                                  top: 10,
                                  right: 10,
                                  background: "#fff",
                                  transition: "background 0.2s",
                                }}
                                onMouseOver={(e) => {
                                  (
                                    e.currentTarget as HTMLElement
                                  ).style.background = "#ffeaea";
                                }}
                                onMouseOut={(e) => {
                                  (
                                    e.currentTarget as HTMLElement
                                  ).style.background = "#fff";
                                }}
                                onClick={async () => {
                                  const urlApi =
                                    "/api/v1/SignPage/delete-comment-sign?id=" +
                                    itemComment.id;
                                  var resSign = await repositorySign.get<
                                    MessageResponse<SignAccessModel>
                                  >(urlApi);
                                  if (
                                    resSign &&
                                    resSign.httpStatusCode === 200
                                  ) {
                                    if (!resSign.success)
                                      NotificationExtension.Fails(
                                        resSign.message ?? "Thất bại !"
                                      );
                                    else {
                                      setListComment((x) =>
                                        x?.filter(
                                          (xx) => xx.id !== itemComment.id
                                        )
                                      );
                                    }
                                  }
                                }}
                              >
                                <IconTrash
                                  style={{ width: 22, height: 22 }}
                                  stroke={1.8}
                                />
                              </ActionIcon>
                            </div>
                            {itemComment.content && (
                              <TypographyStylesProvider>
                                <div
                                  style={{
                                    marginLeft: 44,
                                    marginTop: 2,
                                    fontSize: 15,
                                    color: "#222",
                                    wordBreak: "break-word",
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: itemComment.content,
                                  }}
                                />
                              </TypographyStylesProvider>
                            )}
                            {itemComment.att1 && itemComment.att1.length > 0 && (
                              <div style={{ marginLeft: 44, marginTop: 8 }}>
                                <Button
                                  variant="subtle"
                                  color="orange"
                                  size="xs"
                                  leftSection={<IconPaperclip size={14} />}
                                  onClick={() => {
                                    const files = itemComment.att1
                                      ? itemComment.att1.split(",")
                                      : [];
                                    modals.open({
                                      title: (
                                        <Text fw={600}>Danh sách file đính kèm</Text>
                                      ),
                                      size: "lg",
                                      children: <AttachmentListModal fileUrls={files} />,
                                    });
                                  }}
                                >
                                  {itemComment.att1.split(",").length} file đính kèm
                                </Button>
                              </div>
                            )}
                          </div>
                        ))}

                        {(!listComment || listComment.length === 0) && (
                          <Text c="dimmed" ta="center" mt={40}>
                            Chưa có bình luận nào.
                          </Text>
                        )}
                      </div>
                    </ScrollArea>
                  </div>
                </div>
              </div>
            </Grid.Col>
          </Grid>
        </>
      )}

      {!documentData && <Loading />}
    </>
  );
};

export default SignTopage;

